import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import VendorHederHoc from "./VendorHeaderHoc";
import Select from "../UniversalComponents/SelectComponent";
import Input from "../UniversalComponents/InputComponent";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as Setting } from "../../assets/images/setting.svg";
import VendorHeaderHoc from "./VendorHeaderHoc";

const PrintChecks = () => {
  const [selectedValue, setSelectedValue] = useState("");

  const [selectedTermValue, setSelectedTermValue] = useState("");
  const [inputTextValue, setInputTextValue] = useState("");
  const [inputAccountValue, setInputAccountValue] = useState("");

  const transactionOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const sortOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const AccountOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleSelectTermChange = (e) => {
    setSelectedTermValue(e.target.value);
  };
  const handleInputAccountChange = (e) => {
    setInputAccountValue(e.target.value);
  };
  const handleInputTextChange = (e) => {
    setInputTextValue(e.target.value);
  };
  const handleButtonClick = () => {
    console.log("Button clicked!");
  };
  return (
    <form className="mx-10 ">
      <div className="flex gap-3">
        <div className="bg-white border border-[#D6D3D3] px-4 w-[90%] rounded">
          <div className="space-x-2 flex pt-4 justify-between w-full">
            <div className="w-full">
              <label className=" text-14 text-434852 font-400 pb-1 ">Account</label>
              <Select
                placeholder="Choose An Option"
                options={AccountOptions}
                value={inputAccountValue}
                onChange={handleInputAccountChange}
                style={{ width: "100%", color: "#AFAFAF", fontSize: "12px", height: "35px", padding: "5px" }}
              />
              <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Bal: $ 5,000.00</label>
            </div>
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Transaction type</label>
              <div>
                <Select
                  placeholder={"Choose An Option"}
                  options={transactionOptions}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Sort Type</label>
              <div>
                <Select
                  placeholder="Choose a Terms"
                  options={sortOptions}
                  value={selectedTermValue}
                  onChange={handleSelectTermChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
            </div>
          </div>
          <div className="flex space-x-2 pt-4 pb-4 w-full">
            <div className="w-[33%]">
              <label className=" text-14 text-434852 font-400 pb-1 ">Starting check number *</label>
              <Input
                type="number"
                placeholder="Enter Check Number"
                name="myInput"
                value={inputTextValue}
                onChange={handleInputTextChange}
                style={{ width: "100%", height: "35px", padding: "5px" }}
              />
            </div>
          </div>
        </div>
        <div className=" border border-[#D6D3D3]  h-[200px] bg-white flex justify-center items-center rounded px-12">
          <div className="whitespace-nowrap">
            <Button type="secondary" onClick={handleButtonClick} style={{ padding: "10px 30px" }}>
              Create Check
            </Button>
          </div>
        </div>
      </div>
      <div className="flex justify-end my-4">
        <Setting></Setting>
      </div>
      <div className="bg-white border border-[#D6D3D3] flex justify-center items-center h-[200px] ">
        <div className="flex flex-col items-center ">
          <label className="text-434852 text-18 font-500 ">You're all caught up!</label>
          <p className="text-AFAFAF font-400 text-12 pt-1">
            When you have new checks to print, they'll appear here. If you can't find a check, try changing the account
            or filters.
          </p>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(VendorHeaderHoc(PrintChecks));
